import { TestResultFilter } from "@/models"

export default {
  namespaced: true,

  state: {
    testResultFilter: new TestResultFilter(),
  },

  getters: {
    testResultFilter: state => state.testResultFilter,
  },

  mutations: {
    setTestResultFilter(state, payload) {
      state.testResultFilter = payload
    }
  }
}
